/**
 * Extracts the second part of a pathname that starts with `/v/`
 */
export function getVersion(url: URL | string): string | 'unknown' {
    const convertedUrl = url instanceof URL ? url : new URL(url);
    if (!convertedUrl.pathname.startsWith('/v/')) return 'unknown';
    const version = convertedUrl.pathname.split('/').filter((value) => value.length > 0)[1];
    if (version === undefined || version.length === null) return 'unknown';
    return version;
}
